import React from 'react';
import PropTypes from 'prop-types';
import { resolve } from '@cvent/nucleus-dynamic-css';
import { resolveTestId } from '@cvent/nucleus-test-automation';
/**
# FlipCounter Component
**/
export default class FlipCounter extends React.Component {
  static displayName = 'FlipCounter';
  static propTypes = {
    /** Label text for the counter. */
    label: PropTypes.string,
    /** The actual value to display in the counter. */
    digit: PropTypes.number.isRequired,
    /** Available Style Keys. */
    style: PropTypes.shape({
      /** Top level style applied to the container. */
      counter: PropTypes.object,
      /** Style applied to the wrapper around the digit part of the counter. */
      wrapper: PropTypes.object,
      /** Style applied to the digit part of the counter. */
      digitWrapper: PropTypes.object,
      /** Style applied to the digit. */
      current: PropTypes.object,
      /** Style applied to the digit. */
      top: PropTypes.object,
      /** Style applied to the digit. */
      flip: PropTypes.object,
      /** Style applied to the digit. */
      flipping: PropTypes.object,
      /** Style applied to the digit. */
      digitTop: PropTypes.object,
      /** Style applied to the digit. */
      next: PropTypes.object,
      /** Style applied to the digit. */
      bottom: PropTypes.object,
      /** Style applied to the digit. */
      digit: PropTypes.object,
      /** Style applied to the label part of the counter. */
      label: PropTypes.object
    })
  };
  constructor(props) {
    super(props);
    this.state = {
      flipping: false
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        flipping: true
      });
    });
  }

  componentDidUpdate(prevProps) {
    /* eslint-disable react/no-did-update-set-state */
    // Need to verify if both not numbers becuase equality does not check this.
    if (isNaN(prevProps.digit) && isNaN(this.props.digit)) {
      return;
    }
    if (prevProps.digit === this.props.digit) {
      return;
    }
    this.setState({ flipping: false });
    setTimeout(
      () => this.setState({ flipping: true }),
      20);
  }

  render() {
    return (
      <li {...resolveTestId(this.props)} {...resolve(this.props, 'counter')}>
        <div {...resolve(this.props, 'wrapper')}>
          <div {...resolve(this.props, 'digitWrapper')}>
            <div {...resolve(this.props, 'current', 'top', 'flip', this.state.flipping ? 'flipping' : '')}>
              <div {...resolve(this.props, 'digitTop')}>
                <span>{this.props.digit + 1 === 60 ? 0 : this.props.digit + 1}</span>
              </div>
            </div>
            <div {...resolve(this.props, 'next', 'top', 'flip')}>
              <div {...resolve(this.props, 'digitTop')}>
                <span>{this.props.digit}</span>
              </div>
            </div>
            <div {...resolve(this.props, 'current', 'bottom', 'flip')}>
              <div {...resolve(this.props, 'digit')}>
                <span>{this.props.digit + 1 === 60 ? 0 : this.props.digit + 1}</span>
              </div>
            </div>
            <div {...resolve(this.props, 'next', 'bottom', 'flip', this.state.flipping ? 'flipping' : '')}>
              <div {...resolve(this.props, 'digit')}>
                <span>{this.props.digit}</span>
              </div>
            </div>
          </div>
        </div>
        <span {...resolve(this.props, 'label')}>{this.props.label}</span>
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./~/nucleus-core/counters/FlipCounter.js